<!-- <div class="login-register" style="background-image:url(assets/images/background/login-register.jpg);">
    <div class="login-register-box">
        <mat-card>
            <mat-card-content>
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="text-center">
                        <img alt="homepage" src="assets/images/logo-icon.png" class="image_logo">
                        <h4 class="m-t-0">Login to App</h4>
                    </div>

                    <div fxLayout="row wrap">
                        
                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <mat-form-field>
                                <input matInput placeholder="Username" [formControl]="form.controls['name']">
                            </mat-form-field>
                            <small *ngIf="form.controls['name'].hasError('required') && form.controls['name'].touched" class="text-danger support-text">Username is required.</small>
                        </div>
                        
                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <mat-form-field>
                                <input matInput type="password" placeholder="Password" [formControl]="form.controls['password']">
                            </mat-form-field>
                            <small *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched" class="text-danger support-text">Password is required.</small>
                        </div>
                       
                        <div fxFlex.gt-sm="50" fxFlex.gt-xs="50">
                            <mat-checkbox color="warn">Remember me</mat-checkbox>
                        </div>
                        

                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <button mat-raised-button color="primary" class="btn-block btn-lg m-t-20 m-b-20" type="submit" [disabled]="!form.valid">Login</button>
                        </div>

                    </div>
                </form>
            </mat-card-content>
            <mat-card-header class="bg-danger text-white" id="error_card" *ngIf="errorData">
                <mat-card-title>Error</mat-card-title>
                <mat-card-subtitle>Invalid User Credentials</mat-card-subtitle>
            </mat-card-header>
        </mat-card>

     </div>
</div>  -->


<div class="content-layout">
    <div class="container">
        <div class="logo-container">
            <img style="width: 100px" src="assets/images/oasyslogo.png" alt="" class="img-fluid" />
        </div>
        <div class="row content-row" style="
          border-radius: 20px;
          /* box-shadow: 0 0 15px 4px rgba(13, 14, 13, 0.6); */
        ">
            <div class="col-md-7 login_div">
                <img src="assets/images/MDM.gif" style="width: 76%;height: 86%;">
            </div>
            
            <div class="col-md-5"  style=" display: flex;justify-content: center; align-items: center;background: #7E57C2;">
                <div class="container-fluid">
                    <form [formGroup]="form" (ngSubmit)="onSubmit()">
                        <div class="text-center">
                            <div class="col-md-11">
                                <img style="width: 300px;height: 200px; margin-bottom: -50px;"
                                    src="assets/images/logo-icon.png" alt="" />
                            </div>
                            <br/>
                            <div class="login-heading col-md-11">
                               Employee Field Tracking
                            </div><br/>
                            <div class="col-md-11"
                                style="color: white; font-weight: bolder;font-size: 24px; font-family:Arial, Helvetica, sans-serif;">
                                User Login
                            </div>
                        </div>
                        <br/>
                        <div class="formGroup row">
                            <div class="col-md-11">
                                <div style="display: flex; justify-content: center; align-items: center;color: grey !important;"><input
                                        style="width: 75%;" class="formControl" type="text" formControlName="name"
                                        placeholder="User Name">
                                </div>
                                <div style="display: flex; justify-content: center; align-items: center;">
                                    <small style="float: left;"
                                        *ngIf="(form.controls['name'].hasError('required') && form.controls['name'].touched) || submitted"
                                        class="text-danger support-text">User Name is required.</small>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="formGroup row">
                            <div class="col-md-11">
                                <div style="display: flex; justify-content: center; align-items: center;color: grey !important;"><input
                                        style="width: 75%;" class="formControl" type="password"
                                        formControlName="password" placeholder="Password"></div>
                                <div style="display: flex; justify-content: center; align-items: center;">
                                    <small
                                        *ngIf="(form.controls['password'].hasError('required') && form.controls['password'].touched) || submitted"
                                        class="text-danger support-text">Password is required.</small>
                                </div>
                            </div>
                        </div>
                        <br/>
                      
                        <div class="col-md-11 formGroup row " style="padding:10px flex;justify-content: center;align-items: center;font-weight: bolder;font-family:Arial, Helvetica, sans-serif; ">
                            <button class="login-button" type="submit">LOGIN</button>
                        </div>
                       
                        <br/>
                        
                        <div class="text-danger" style="background-color: bisque; padding: 10px;" *ngIf="errorData">
                            Login Failed:Invalid User Credentials
                        </div>
                    </form>
                    
                    <div class="login-footer">
                    <span>
                        Copyrights © {{ curryear }} OASYS Cybernetics Pvt Ltd. All rights reserved.
                    </span>
                        <div class="privacy-link"><a href="https://oasys.co/privacy-policy.html" target="_blank">Privacy Policy </a>|
                            <a href="https://oasys.co/terms.html" target="_blank">Terms & Condition</a>
                          </div>
                
                </div>
                    <!-- <form [formGroup]="form" class="w-100 p-4" (ngSubmit)="onSubmit()" style="margin-left: 10%;">
                        <div class="text-center" style="width: 80%;">
                            <img alt="homepage" src="assets/images/logo-icon.png" class="image_logo">
                            <h4 class="m-t-0 white-color">Login to App</h4>
                        </div>

                        <div fxLayout="row wrap" class="white-color">
                            
                            <div fxFlex.gt-sm="80" fxFlex.gt-xs="80" fxFlex="80">
                                <mat-form-field>
                                    <input matInput placeholder="Username" [formControl]="form.controls['name']">
                                </mat-form-field>
                                <small *ngIf="form.controls['name'].hasError('required') && form.controls['name'].touched" class="text-danger support-text">Username is required.</small>
                            </div>
                            
                            <div fxFlex.gt-sm="80" fxFlex.gt-xs="80" fxFlex="80">
                                <mat-form-field>
                                    <input matInput type="password" placeholder="Password" [formControl]="form.controls['password']">
                                </mat-form-field>
                                <small *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched" class="text-danger support-text">Password is required.</small>
                            </div>
                        
 

                            <div fxFlex.gt-sm="80" fxFlex.gt-xs="80" fxFlex="80">
                                <button mat-raised-button color="primary" class="btn-block btn-lg m-t-20 m-b-20" type="submit" [disabled]="!form.valid">Login</button>
                            </div>

                            <mat-card-header class="bg-danger text-white" id="error_card" *ngIf="errorData">
                                <mat-card-title>Error</mat-card-title>
                                <mat-card-title>Invalid User Credentials</mat-card-title>
                            </mat-card-header>
                            
                        </div>
                    
                    </form>  -->

                </div>
            </div>
        </div>
    </div>
   
</div>
